import _regeneratorValues from "/root/workspace/__flow_work/__flow_builds/50aad046-ad0a-440d-80a1-803b30af1c95/workspace/wellcee-admin_pro/node_modules/.pnpm/@babel/runtime@7.28.6/node_modules/@babel/runtime/helpers/esm/regeneratorValues.js";
import _regeneratorKeys from "/root/workspace/__flow_work/__flow_builds/50aad046-ad0a-440d-80a1-803b30af1c95/workspace/wellcee-admin_pro/node_modules/.pnpm/@babel/runtime@7.28.6/node_modules/@babel/runtime/helpers/esm/regeneratorKeys.js";
import _regenerator from "/root/workspace/__flow_work/__flow_builds/50aad046-ad0a-440d-80a1-803b30af1c95/workspace/wellcee-admin_pro/node_modules/.pnpm/@babel/runtime@7.28.6/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "/root/workspace/__flow_work/__flow_builds/50aad046-ad0a-440d-80a1-803b30af1c95/workspace/wellcee-admin_pro/node_modules/.pnpm/@babel/runtime@7.28.6/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.join.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/web.dom-collections.iterator.js";
import userPopMixin from "@/views/system/index/mixin/userPopMixin";
import dayjs from "dayjs";
export default {
  mixins: [userPopMixin],
  name: "user-list",
  data: function data() {
    return {
      env: process.env.NODE_ENV,
      pickerOptions: {
        disabledDate: function disabledDate(time) {
          return time.getTime() > Date.now() - 8.64e6;
        }
      },
      searchForm: {
        time: [],
        pn: 1,
        ps: 20,
        name: "",
        fuzzy: 0,
        phone: this.$route.query.phone || "",
        user_type: "",
        createTime_start: "",
        createTime_end: "",
        isDefriend: "",
        imCount: "",
        thirdLogin: "",
        prefix: "",
        minAge: "",
        maxAge: ""
      },
      // 搜索表单
      getPhonePrefixLoading: false,
      phonePrefixList: [],
      tableLoading: false,
      tableData: [],
      // 表格数据
      total: 0,
      remarkDialogVisible: false,
      currentRemarkObj: {}
    };
  },
  watch: {
    $route: function $route() {
      if (this.$route.query.phone) {
        this.searchForm.phone = this.$route.query.phone;
        this.getData();
      }
    }
  },
  mounted: function mounted() {
    var _this = this;
    return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
      return _regenerator().w(function (_context) {
        while (1) switch (_context.n) {
          case 0:
            _this.getData();
            _this.getPhoneCodeList();
          case 1:
            return _context.a(2);
        }
      }, _callee);
    }))();
  },
  methods: {
    goBrandUserList: function goBrandUserList(row) {
      window.open("#/brand/user?phone=".concat(this.formatPhone(row.phone)));
    },
    goQuarterUserList: function goQuarterUserList(row) {
      window.open("#/quarter/userNew?phone=".concat(this.formatPhone(row.phone), "&status=null"));
    },
    // type_category 新增诈骗标识
    setUserDisableSendMsg: function setUserDisableSendMsg(row, type, category) {
      var _this2 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        var code;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              _context2.n = 1;
              return _this2.$api.setUserDisableSendMsg({
                user_id: row.id,
                type_id: type,
                type_category: category || 'manual'
              });
            case 1:
              if (type == 3) {
                row.disable_send_msg_at = +new Date() / 1000 + 3 * 3600 * 24;
              } else {
                row.disable_send_msg_at = type;
              }
              row.disable_send_msg = type == 0 ? 0 : 1;
              _this2.visible = false;
              // 操作上报
              code = '';
              if (type == 3) {
                code = '3daymute';
              } else if (type == 7) {
                code = '7daymute';
              } else if (type == -1) {
                code = 'permamute';
              } else if (type == 0) {
                code = 'cancelmute';
              }
              _this2.$operationLog.push({
                code: code,
                userId: row.id,
                operationType: "user",
                detailBatchNo: row.id
              });
            case 2:
              return _context2.a(2);
          }
        }, _callee2);
      }))();
    },
    formatPhone: function formatPhone(phone) {
      if (phone.indexOf("+") > -1) {
        return phone.split(" ")[1];
      } else {
        return phone;
      }
    },
    goHouseList: function goHouseList(row) {
      window.open("#/house/list?phone=".concat(this.formatPhone(row.phone)));
    },
    goChat: function goChat(row) {
      window.open("#/im/chat?otherId=".concat(row.id));
    },
    setRemarkDialog: function setRemarkDialog(row) {
      this.currentRemarkObj = row;
      this.remarkDialogVisible = true;
    },
    pageChange: function pageChange(pn) {
      this.searchForm.pn = pn;
      this.getData();
    },
    getUserDeviceRiskBatch: function getUserDeviceRiskBatch() {
      var _this3 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3() {
        var userIds, res, _loop, key, _t, _t2;
        return _regenerator().w(function (_context4) {
          while (1) switch (_context4.n) {
            case 0:
              userIds = [];
              _this3.tableData.forEach(function (item) {
                userIds.push(item.id);
              });
              _context4.n = 1;
              return _this3.$api.getUserDeviceRiskBatch({
                user_ids: userIds.join(",")
              });
            case 1:
              res = _context4.v;
              _loop = /*#__PURE__*/_regenerator().m(function _loop(key) {
                return _regenerator().w(function (_context3) {
                  while (1) switch (_context3.n) {
                    case 0:
                      _this3.tableData.forEach(function (item) {
                        if (item.id == key) {
                          _this3.$set(item, "deviceRiskInfo", res.data[key]);
                        }
                      });
                    case 1:
                      return _context3.a(2);
                  }
                }, _loop);
              });
              _t = _regeneratorKeys(res.data);
            case 2:
              if ((_t2 = _t()).done) {
                _context4.n = 4;
                break;
              }
              key = _t2.value;
              return _context4.d(_regeneratorValues(_loop(key)), 3);
            case 3:
              _context4.n = 2;
              break;
            case 4:
              return _context4.a(2);
          }
        }, _callee3);
      }))();
    },
    getUsersTagList: function getUsersTagList() {
      var _this4 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4() {
        var userIds, res, _loop2, key, _t3, _t4;
        return _regenerator().w(function (_context6) {
          while (1) switch (_context6.n) {
            case 0:
              userIds = [];
              _this4.tableData.forEach(function (item) {
                userIds.push(item.id);
              });
              _context6.n = 1;
              return _this4.$api.getUsersTagList({
                top: 5,
                user_id: userIds.join(",")
              });
            case 1:
              res = _context6.v;
              _loop2 = /*#__PURE__*/_regenerator().m(function _loop2(key) {
                return _regenerator().w(function (_context5) {
                  while (1) switch (_context5.n) {
                    case 0:
                      _this4.tableData.forEach(function (item) {
                        if (item.id == key) {
                          _this4.$set(item, "userTag", res.data[key]);
                        }
                      });
                    case 1:
                      return _context5.a(2);
                  }
                }, _loop2);
              });
              _t3 = _regeneratorKeys(res.data);
            case 2:
              if ((_t4 = _t3()).done) {
                _context6.n = 4;
                break;
              }
              key = _t4.value;
              return _context6.d(_regeneratorValues(_loop2(key)), 3);
            case 3:
              _context6.n = 2;
              break;
            case 4:
              return _context6.a(2);
          }
        }, _callee4);
      }))();
    },
    userStatusChangeFilter: function userStatusChangeFilter(value) {
      if (value != '') {
        var start = dayjs().subtract(1, 'month').format('YYYY-MM-DD');
        var end = dayjs().format('YYYY-MM-DD');
        this.searchForm.time = [start, end];
      } else {
        this.searchForm.time = [];
      }
      this.getData('search');
    },
    prefixChangeFilter: function prefixChangeFilter(value) {
      if (value != '') {
        var start = dayjs().subtract(1, 'month').format('YYYY-MM-DD');
        var end = dayjs().format('YYYY-MM-DD');
        this.searchForm.time = [start, end];
      } else {
        this.searchForm.time = [];
      }
      this.getData('search');
    },
    getData: function getData(type) {
      var _this5 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee5() {
        var _this5$searchForm$tim, _this5$searchForm$tim2;
        var searchForm, _this5$searchForm$tim3, _this5$searchForm$tim4, res, time;
        return _regenerator().w(function (_context7) {
          while (1) switch (_context7.n) {
            case 0:
              if (type === "search") {
                _this5.searchForm.pn = 1;
              }
              searchForm = {
                pn: _this5.searchForm.pn,
                ps: _this5.searchForm.ps,
                name: _this5.searchForm.name,
                phone: _this5.searchForm.phone,
                fuzzy: _this5.searchForm.fuzzy,
                user_type: _this5.searchForm.user_type,
                createTime_start: null,
                createTime_end: null,
                isDefriend: _this5.searchForm.isDefriend,
                imCount: _this5.searchForm.imCount,
                thirdLogin: _this5.searchForm.thirdLogin,
                iso: _this5.searchForm.prefix,
                minAge: _this5.searchForm.minAge,
                maxAge: _this5.searchForm.maxAge,
                device: _this5.searchForm.device,
                time: _this5.searchForm.time
              };
              if ((_this5$searchForm$tim = _this5.searchForm.time) !== null && _this5$searchForm$tim !== void 0 && _this5$searchForm$tim[0] || (_this5$searchForm$tim2 = _this5.searchForm.time) !== null && _this5$searchForm$tim2 !== void 0 && _this5$searchForm$tim2[1]) {
                searchForm.createTime_start = (_this5$searchForm$tim3 = _this5.searchForm.time) === null || _this5$searchForm$tim3 === void 0 ? void 0 : _this5$searchForm$tim3[0];
                searchForm.createTime_end = (_this5$searchForm$tim4 = _this5.searchForm.time) === null || _this5$searchForm$tim4 === void 0 ? void 0 : _this5$searchForm$tim4[1];
              }
              delete searchForm.time;
              if (_this5.searchForm.isDefriend == 3) {
                // 高危IP
                searchForm.isDefriend = "";
                searchForm.blackIp = 1;
              }
              if (_this5.searchForm.isDefriend == 4) {
                // 已实名
                searchForm.isDefriend = "";
                searchForm.realName = 1;
              }
              // if (this.searchForm.isDefriend == 5) {
              //     // 禁言7天
              //     searchForm.isDefriend = "";
              //     searchForm.disable_send_msg = 7;
              // }
              if (_this5.searchForm.isDefriend == 5) {
                // 禁言3天
                searchForm.isDefriend = "";
                searchForm.disable_send_msg = 3;
              }
              if (_this5.searchForm.isDefriend == 6) {
                // 永久禁言
                searchForm.isDefriend = "";
                searchForm.disable_send_msg = -1;
              }
              if (_this5.searchForm.isDefriend == 7) {
                // 虚拟号
                searchForm.isDefriend = "";
                searchForm.virtualNumber = 1;
              }
              if (_this5.searchForm.isDefriend == 8) {
                // 虚拟号
                searchForm.isDefriend = "";
                searchForm.status = -1;
              }
              if (_this5.searchForm.isDefriend == 9) {
                // 虚拟号
                searchForm.isDefriend = "";
                searchForm.auth_type = 1;
              }
              if (_this5.searchForm.isDefriend == 10) {
                // 虚拟号
                searchForm.isDefriend = "";
                searchForm.noDeviceId = 1;
              }
              _this5.tableLoading = true;
              _context7.n = 1;
              return _this5.$api.getUserList(searchForm);
            case 1:
              res = _context7.v;
              time = +new Date() / 1000;
              res.data.list.forEach(function (item) {
                item.phone_prefix = item.phone.split(" ")[0];
                item.phone = item.phone.split(" ")[1];
                if (item.disable_send_msg_at == -1 || item.disable_send_msg_at > time) {
                  item.disable_send_msg = 1;
                } else {
                  item.disable_send_msg = 0;
                }
              });
              _this5.tableData = res.data.list;
              _this5.total = res.data.count;
              _this5.tableLoading = false;
              _this5.getUsersTagList();
              _this5.getUserDeviceRiskBatch();
              _this5.getUserListByIds(_this5.tableData, "id");
            case 2:
              return _context7.a(2);
          }
        }, _callee5);
      }))();
    },
    getPhoneCodeList: function getPhoneCodeList(name) {
      var _this6 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee6() {
        var res;
        return _regenerator().w(function (_context8) {
          while (1) switch (_context8.n) {
            case 0:
              _this6.getPhonePrefixLoading = true;
              _context8.n = 1;
              return _this6.$api.getPhoneCodeList({
                ch: name
              });
            case 1:
              res = _context8.v;
              res.data.list.unshift({
                ch: "海外",
                prefix: "00"
              });
              _this6.phonePrefixList = res.data.list;
              _this6.getPhonePrefixLoading = false;
            case 2:
              return _context8.a(2);
          }
        }, _callee6);
      }))();
    },
    toggleImVersion: function toggleImVersion(row) {
      var _this7 = this;
      this.$confirm("\u5207\u6362\u4E3A".concat(row.im_company == 'rongcloud' ? '腾讯' : '融云'), "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee7() {
        return _regenerator().w(function (_context9) {
          while (1) switch (_context9.n) {
            case 0:
              _context9.n = 1;
              return _this7.$api.toggleImVersion({
                userId: row.id,
                sdk: row.im_company == 'rongcloud' ? 'tencent' : 'rongcloud'
              });
            case 1:
              _this7.$message.success("操作成功");
              _this7.getData();
            case 2:
              return _context9.a(2);
          }
        }, _callee7);
      }))).catch(function () {});
    },
    // 拉黑 | 恢复
    setUserDefriend: function setUserDefriend(row, type) {
      var _this8 = this;
      this.$confirm("确认操作， 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee8() {
        var code;
        return _regenerator().w(function (_context0) {
          while (1) switch (_context0.n) {
            case 0:
              _context0.n = 1;
              return _this8.$api.setUserDefriend({
                userId: row.id,
                type: type
              });
            case 1:
              row.isDefriend = type;
              _this8.$message.success("操作成功");
              // 操作上报
              code = type == 1 ? 'block' : 'unblock';
              _this8.$operationLog.push({
                code: code,
                userId: row.id,
                operationType: "user",
                detailBatchNo: row.id
              });
            case 2:
              return _context0.a(2);
          }
        }, _callee8);
      }))).catch(function () {});
    },
    updateItem: function updateItem(row) {
      this.$router.push({
        path: "/user/update",
        query: {
          id: row.id,
          from: "user_userlist"
        }
      });
    },
    tableRowClassName: function tableRowClassName(_ref3) {
      var row = _ref3.row;
      if (row.isSensitive) {
        return "warning-row";
      }
      if (row.disable_send_msg !== 0) {
        return "gray-row";
      }
      if (row.blackIp) {
        return "black-ip-row";
      }
      return "";
    },
    toPage: function toPage(row) {
      if (row.idcard_number) {
        window.open("#/user/real-name?number=".concat(row.idcard_number));
      }
    }
  }
};